/**
 * The class for a wrapper that only code focuses (`tabIndex={-1}`: a notice the page moves focus to after a refusal, so
 * a screen reader reads it). It is not a control, so it shows no focus ring — not even the one Chrome draws for focus
 * moved by code before any click. The rule lives in tokens.scss (global, inside the new layer).
 */
export const FOCUS_TARGET = "cy-focus-target";
